var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircleOutline20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.121 9.243a1 1 0 10-1.414 1.414l2.121 2.121a1 1 0 001.415 0l3.535-3.535a1 1 0 00-1.414-1.415l-2.828 2.829L8.12 9.243z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-2 0a6 6 0 11-12 0 6 6 0 0112 0z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMTIxMzIgOS4yNDI2NkM3LjczMDggOC44NTIxNCA3LjA5NzYzIDguODUyMTQgNi43MDcxMSA5LjI0MjY2QzYuMzE2NTggOS42MzMxOSA2LjMxNjU4IDEwLjI2NjQgNi43MDcxMSAxMC42NTY5TDguODI4NDMgMTIuNzc4MkM5LjIxODk1IDEzLjE2ODcgOS44NTIxMiAxMy4xNjg3IDEwLjI0MjYgMTIuNzc4MkwxMy43NzgyIDkuMjQyNjZDMTQuMTY4NyA4Ljg1MjE0IDE0LjE2ODcgOC4yMTg5NyAxMy43NzgyIDcuODI4NDVDMTMuMzg3NyA3LjQzNzkyIDEyLjc1NDUgNy40Mzc5MiAxMi4zNjQgNy44Mjg0NUw5LjUzNTUzIDEwLjY1NjlMOC4xMjEzMiA5LjI0MjY2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTggMTBDMTggMTQuNDE4MyAxNC40MTgzIDE4IDEwIDE4QzUuNTgxNzIgMTggMiAxNC40MTgzIDIgMTBDMiA1LjU4MTcyIDUuNTgxNzIgMiAxMCAyQzE0LjQxODMgMiAxOCA1LjU4MTcyIDE4IDEwWk0xNiAxMEMxNiAxMy4zMTM3IDEzLjMxMzcgMTYgMTAgMTZDNi42ODYyOSAxNiA0IDEzLjMxMzcgNCAxMEM0IDYuNjg2MjkgNi42ODYyOSA0IDEwIDRDMTMuMzEzNyA0IDE2IDYuNjg2MjkgMTYgMTBaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgCheckCircleOutline20 as ReactComponent };